import Wochenbrief from "../../../api/model/Wochenbrief"
import { gradientForLetter } from "./gradients"
import "./WochenbriefKZO.scss"

interface WochenbriefKZOProps {
  letter: Wochenbrief
}

const WochenbriefKZO = (props: WochenbriefKZOProps) => {
  const { letter } = props
  const [from, to] = gradientForLetter(letter.title, letter.period, letter.content)

  return (
    <article className="wochenbrief-kzo">
      <header
        className="wochenbrief-header"
        style={{ backgroundImage: `linear-gradient(90deg, ${from}, ${to})` }}
      >
        <h2>{letter.title}</h2>
        {letter.period.length > 0 && <div className="wochenbrief-badge">{letter.period}</div>}
      </header>
      <div className="wochenbrief-body" dangerouslySetInnerHTML={{ __html: letter.content }} />
    </article>
  )
}

export default WochenbriefKZO
